import dynamic from 'next/dynamic';

import { HotelOverviewComponentProps } from './HotelOverview.types';

export const HotelOverviewMGP = dynamic<HotelOverviewComponentProps>(() =>
  import('./HotelOverview').then(module => module.HotelOverview)
);
